import { useState, useEffect } from 'react';
import PageHeading from '../../components/PageHeading'
import { UserOutlined, DeleteOutlined } from '@ant-design/icons';
import { message, Table, Popconfirm, Button } from 'antd';
import axiosInstance from '../../utils/axios';
import { dateFormat } from '../../utils/dateFormats';

const Subscribers = () => {
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [subs, setSubs] = useState({
        current_page: 1,
        page_size: 20,
        results: [],
    });

    useEffect(() => {
        fetchData();
    }, [page]);

    const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get(`subscription/subscription/?page=${page}`);
			setSubs(response.data);
		} catch (error) {
			message.error("Failed to fetch theatre");
		} finally {
			setLoading(false);
		}
	};

    const confirm = async (id) => {
        try {
            await axiosInstance.delete(`subscription/subscription/${id}`);
            message.success("Deleted successfully");
            fetchData();
        } catch (err) {
            message.error("Cannot delete");
        }
    };

    const cancel = () => message.info('Cancelled');
    
    const columns = [
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Subscribed At",
            dataIndex: "created_at",
            key: "created_at",
            render: (text) => dateFormat(text),
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'actions',
            render: (_, record) => (
                <>
                    <Popconfirm
                        title="Delete"
                        description="Are you sure want to delete user?"
                        onConfirm={() => confirm(record.id)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </>
            )
        },
    ];

    return (
        <div className='dashboard'>
		    <PageHeading name="Subscribers" icon={<UserOutlined/>} />
            <Table
                dataSource={subs.results}
                loading={loading}
                columns={columns}
                rowKey="id"
                scroll={{ x: "max-content" }}
                pagination={{
                    current: page,
                    pageSize: 20,
                    total: subs.count,
                    onChange: (newPage, _) => {
                    setPage(newPage);
                    },
                }}
                />
        </div>
    )
}

export default Subscribers
